import {b64DecodeToUrl} from "utils/helpers";

const XLSX_MIME =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const parsePaymentsFiltersFromSearch = search => {
    const p = new URLSearchParams(search);
    const s = k => p.get(k);
    const arr = k => {
        const v = s(k);
        return v
            ? v
                  .split(",")
                  .map(x => x.trim())
                  .filter(Boolean)
            : undefined;
    };
    const aw = s("allWithdrawRequests");
    const allWithdrawRequests =
        aw === "1" || aw === "true" || aw === "yes";

    return {
        status: arr("status"),
        city: arr("city"),
        zone: arr("zone"),
        zoneManagement: arr("zoneManagement"),
        searchText: s("searchText") || undefined,
        allWithdrawRequests,
        startDate: s("startDate") || undefined,
        endDate: s("endDate") || undefined
    };
};

/** API: Yalnızca allWithdrawRequests açıkken tarih gönderilir (isteğe bağlı startDate/endDate). Mod kapalıyken tarih parametresi yok. */
export const buildListRequestParams = filterValues => {
    const {
        status,
        city,
        zone,
        zoneManagement,
        searchText,
        allWithdrawRequests,
        startDate,
        endDate
    } = filterValues;

    const base = {
        status,
        city,
        zone,
        zoneManagement,
        searchText
    };

    if (!allWithdrawRequests) {
        return base;
    }

    const params = {
        ...base,
        allWithdrawRequests: true
    };
    if (startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
    }
    return params;
};

/** Excel indirme ile aynı filtre gövdesi + excel */
export const buildExcelRequestParams = filterValues => ({
    ...buildListRequestParams(filterValues),
    excel: true
});

export const appendPaymentsParamsToUrl = (parts, next) => {
    const appendParam = (key, raw) => {
        if (raw == null || raw === "") return;
        const v = Array.isArray(raw) ? raw.join(",") : raw;
        if (!v && v !== 0) return;
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`);
    };

    appendParam("status", next.status);
    appendParam("city", next.city);
    appendParam("zone", next.zone);
    appendParam("zoneManagement", next.zoneManagement);
    appendParam("searchText", next.searchText);

    if (next.allWithdrawRequests) {
        appendParam("allWithdrawRequests", "1");
        appendParam("startDate", next.startDate);
        appendParam("endDate", next.endDate);
    }
};

/**
 * Excel GET yanıtı: blob (xlsx), JSON blob veya doğrudan base64 string / { data }
 */
export const parseExcelExportResponse = async data => {
    if (data instanceof Blob) {
        const ct = (data.type || "").toLowerCase();
        const looksLikeSheet =
            ct.includes("spreadsheetml") ||
            ct.includes("ms-excel") ||
            ct.includes("octet-stream") ||
            (ct === "" && data.size > 0);

        if (looksLikeSheet && !ct.includes("json") && !ct.includes("text/plain")) {
            const url = URL.createObjectURL(
                data.type ? data : new Blob([data], {type: XLSX_MIME})
            );
            return {url, revoke: () => URL.revokeObjectURL(url)};
        }

        const text = await data.text();
        try {
            const json = JSON.parse(text);
            if (json.message && (json.status === "error" || json.statusCode >= 400)) {
                throw new Error(json.message);
            }
            const b64 = json.base64Excel ?? json.data;
            if (typeof b64 === "string" && b64.length > 0) {
                const url = await b64DecodeToUrl(b64, XLSX_MIME);
                return {url, revoke: () => URL.revokeObjectURL(url)};
            }
        } catch (e) {
            if (e instanceof SyntaxError) {
                throw new Error("Excel yanıtı okunamadı.");
            }
            throw e;
        }
        throw new Error("Excel yanıtı okunamadı.");
    }

    if (typeof data === "string" && data.length > 0) {
        const url = await b64DecodeToUrl(data, XLSX_MIME);
        return {url, revoke: () => URL.revokeObjectURL(url)};
    }

    if (data && (data.base64Excel != null || data.data != null)) {
        const b64 = data.base64Excel ?? data.data;
        if (typeof b64 === "string" && b64.length > 0) {
            const url = await b64DecodeToUrl(b64, XLSX_MIME);
            return {url, revoke: () => URL.revokeObjectURL(url)};
        }
    }

    throw new Error("Beklenmeyen Excel yanıtı.");
};
